import { render, staticRenderFns } from "./header-user.vue?vue&type=template&id=2faca852&scoped=true&"
import script from "./header-user.vue?vue&type=script&lang=js&"
export * from "./header-user.vue?vue&type=script&lang=js&"
import style0 from "./header-user.vue?vue&type=style&index=0&id=2faca852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faca852",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
